import { isFeatureAvailiable } from './isFeatureAvailiable'
import type { EnumsV1FeatureId, SettingsV1FeatureLimit } from '@sdk/Api'
import { type Writable, derived, writable } from 'svelte/store'

export const subscriptionPlanFeatures: Writable<EnumsV1FeatureId[]> = writable([])
export const subscriptionPlanFeatureLimits: Writable<SettingsV1FeatureLimit[]> = writable([])

export const checkFeature = derived(
	[subscriptionPlanFeatures, subscriptionPlanFeatureLimits],
	([$features, $featuresLimits]) =>
		(feature: EnumsV1FeatureId, usage: number | null = null) =>
			isFeatureAvailiable(feature, $features, $featuresLimits, usage),
)
